import { AxiosResponse } from "axios";
import apiClient from "../apiClient/apiClient";
import { useQuery } from 'react-query';
import { ProductGroupDetailType } from "./productGroupDetail.type";


export const useProductGroupDetails = () => {
    return useQuery<AxiosResponse<ProductGroupDetailType[]>>('productGroupDetails', () => apiClient.get<ProductGroupDetailType[]>('/product-group-details'))
}